import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import {
    getOnePersona,
    getAllPersonas,
    actualizarPersona,
    actualizarFotoPerfil,
    eliminarFotoPerfil,
} from "../../../services/persona.service";
import { AdministradorNavbar } from "../../../components/common/navbar/AdministradorNavbar";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { showErrorAlert } from "../../../components/molecules/ShowAlert";
import { getAllPaises } from "../../../services/pais.service";
import { getAllDepartamentosByIdPais } from "../../../services/departamento.service";
import { getAllProvinciasByIdDepartamento } from "../../../services/provincia.service";
import { BASE_URL } from "../../../utils/configAxios";
import { getImagePerfil } from "../../../services/image.service";

const obtenerUsuarioLocal = () => {
    try {
        const user = JSON.parse(localStorage.getItem("userInfoES") || "{}");
        return user?.id ? user : null;
    } catch {
        return null;
    }
};

// Función para convertir archivo a base64
const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
    });
};

// Función para cargar imagen desde localStorage
const loadImageFromLocalStorage = (idPersona) => {
    try {
        const storageKey = `perfil_image_${idPersona}`;
        const imageData = localStorage.getItem(storageKey);
        if (!imageData) return null;

        const parsed = JSON.parse(imageData);
        const cachedImage = parsed?.image;

        if (typeof cachedImage !== "string" || cachedImage.trim() === "") {
            localStorage.removeItem(storageKey);
            return null;
        }

        if (cachedImage.startsWith("blob:")) {
            console.warn(`Eliminando imagen cacheada obsoleta (blob) en ${storageKey}`);
            localStorage.removeItem(storageKey);
            return null;
        }

        return cachedImage;
    } catch (error) {
        console.error("Error al cargar imagen desde localStorage:", error);
    }
    return null;
};

export const EditarPerfilAdmPage = () => {
    const [imagenPreview, setImagenPreview] = useState(null);
    const [idPersona, setIdPersona] = useState(null);
    const navigate = useNavigate();
    const { register, handleSubmit, reset } = useForm();
    const [paises, setPaises] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [paisSeleccionado, setPaisSeleccionado] = useState(null);
    const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(null);
    const [provinciaSeleccionada, setProvinciaSeleccionada] = useState(null);

    useEffect(() => {
        const cargarDatos = async () => {
          const usuario = obtenerUsuarioLocal();
          if (!usuario) {
            toast.error("No se encontró sesión activa.");
            return;
          }
      
          try {
            const personas = await getAllPersonas();
            const personaUsuario = personas.find(p => p.usuarioid === usuario.id);
            if (!personaUsuario) {
              toast.error("No se encontró tu persona asociada.");
              return;
            }
      
            const persona = await getOnePersona(personaUsuario.idPersona);
            setIdPersona(persona.idPersona);
      
            // ✅ Cargar todos los países primero
            const paisesResult = await getAllPaises();
            setPaises(paisesResult);
      
            // ✅ Buscar Bolivia por nombre
            const paisBolivia = paisesResult.find(p => p.nombre === "Bolivia");
      
            if (paisBolivia) {
              setPaisSeleccionado(paisBolivia.idPais);
      
              const departamentosResult = await getAllDepartamentosByIdPais(paisBolivia.idPais);
              setDepartamentos(departamentosResult);
      
              if (persona.idDepartamento) {
                setDepartamentoSeleccionado(persona.idDepartamento);
      
                const provinciasResult = await getAllProvinciasByIdDepartamento(persona.idDepartamento);
                setProvincias(provinciasResult);
      
                if (persona.idProvincia) {
                  setProvinciaSeleccionada(persona.idProvincia);
                }
              }
            }
      
            reset({
              correo: persona.correo,
              celular: persona.celular,
              fechaNacimiento: persona.fechaNacimiento?.split("T")[0],
            });
      
            // Primero intentar cargar desde localStorage
            const localImage = loadImageFromLocalStorage(persona.idPersona);
            if (localImage) {
              setImagenPreview(localImage);
            } else if (persona.imagen) {
              const partes = persona.imagen.split("/");
              const fileName = partes[partes.length - 1];
              try {
                const blobUrl = await getImagePerfil(fileName);
                setImagenPreview(blobUrl);
              } catch {
                const imagenCompleta = `${BASE_URL}/${persona.imagen}`;
                setImagenPreview(imagenCompleta);
              }
            }
          } catch (err) {
            console.error(err);
            toast.error("Error al cargar los datos.");
          }
        };
      
        cargarDatos();
      }, [reset]);
      
      
      

    const handlePaisChange = async (e) => {
        const idPais = e.target.value;
        setPaisSeleccionado(idPais);
        setDepartamentoSeleccionado(null);
        setProvinciaSeleccionada(null);
        setDepartamentos(await getAllDepartamentosByIdPais(idPais));
        setProvincias([]);
    };

    const handleDepartamentoChange = async (e) => {
        const idDepartamento = e.target.value;
        setDepartamentoSeleccionado(idDepartamento);
        setProvinciaSeleccionada(null);
        setProvincias(await getAllProvinciasByIdDepartamento(idDepartamento));
    };

    const handleProvinciaChange = (e) => {
        setProvinciaSeleccionada(e.target.value);
    };


    const onSubmit = async (data) => {
        try {
            const persona = await getOnePersona(idPersona);
            const personaData = {
                ...persona,
                correo: data.correo,
                celular: data.celular,
                fechaNacimiento: data.fechaNacimiento,
                idPais: paisSeleccionado,
                idDepartamento: departamentoSeleccionado,
                idProvincia: provinciaSeleccionada,
            };

            await actualizarPersona(idPersona, personaData);

            let persistidoEnBackend = false;

            if (data.imagen && data.imagen.length > 0) {
                const file = data.imagen[0];

                const formData = new FormData();
                formData.append("IdPersona", idPersona);
                formData.append("Foto", file);

                let imagenGuardadaUrl = null;
                let rutaPersistida = null;
                let fileNamePersistido = null;

                try {
                    await actualizarFotoPerfil(formData);

                    let intentos = 0;
                    const maxIntentos = 5;
                    const obtenerPersonaActualizada = async () => {
                        try {
                            return await getOnePersona(idPersona);
                        } catch {
                            return null;
                        }
                    };

                    let personaActualizada = await obtenerPersonaActualizada();
                    while (
                        intentos < maxIntentos &&
                        (!personaActualizada?.imagen ||
                            personaActualizada.imagen === "null" ||
                            (typeof personaActualizada.imagen === "string" && personaActualizada.imagen.trim() === ""))
                    ) {
                        intentos += 1;
                        const espera = intentos * 400;
                        await new Promise((resolve) => setTimeout(resolve, espera));
                        personaActualizada = await obtenerPersonaActualizada();
                    }

                    rutaPersistida = personaActualizada?.imagen || null;

                    if (rutaPersistida) {
                        const partes = String(rutaPersistida).split("/");
                        fileNamePersistido = partes[partes.length - 1];

                        try {
                            imagenGuardadaUrl = await getImagePerfil(fileNamePersistido);
                            persistidoEnBackend = true;
                        } catch {
                            imagenGuardadaUrl = `${BASE_URL}/${rutaPersistida}`;
                        }
                    }
                } catch (uploadErr) {
                    console.error("Error al subir imagen al backend:", uploadErr);
                    toast.warn("La imagen se guardó solo localmente (no en el servidor).");
                }

                if (!imagenGuardadaUrl) {
                    imagenGuardadaUrl = await convertFileToBase64(file);
                    fileNamePersistido = fileNamePersistido || file.name;
                }

                const imageData = {
                    idPersona,
                    image: imagenGuardadaUrl,
                    fileName: fileNamePersistido || file.name,
                    rutaBD: rutaPersistida || null,
                    uploadDate: new Date().toISOString(),
                    persistidoEnBackend,
                };

                localStorage.setItem(`perfil_image_${idPersona}`, JSON.stringify(imageData));
                setImagenPreview(imagenGuardadaUrl);
                window.dispatchEvent(new CustomEvent('imageUpdated'));

                if (persistidoEnBackend) {
                    toast.success("Foto de perfil actualizada en el servidor.");
                } else {
                    toast.warn("La imagen se guardó solo en este dispositivo. Intenta nuevamente más tarde.");
                }
            }

            if (persistidoEnBackend) {
                toast.success("Perfil actualizado correctamente.");
            }
            navigate("/perfilAdm");
        } catch (err) {
            console.error(err);
            toast.error("Error al actualizar tu perfil.");
        }
    };

    const handleEliminarFoto = async () => {
        try {
            if (idPersona) {
                // Eliminar de localStorage
                localStorage.removeItem(`perfil_image_${idPersona}`);
                setImagenPreview(null);
                toast.success("Foto eliminada correctamente.");
            }
        } catch (err) {
            console.error(err);
            toast.error("Error al eliminar foto de perfil.");
        }
    };

    // Iconos para campos
    const getFieldIcon = (fieldName) => {
        const iconMap = {
            correo: "✉️",
            celular: "📱",
            fechaNacimiento: "📅",
            imagen: "📷",
            pais: "🌎",
            departamento: "📍",
            provincia: "🗺️",
        };
        return iconMap[fieldName] || "📋";
    };

    return (
        <div className="bg-gradient-to-br from-blue-50 via-white to-yellow-50 min-h-screen">
            <AdministradorNavbar />
            <ContenedorPageTemplate fondo={false}>
                {/* Header con gradiente */}
                <div className="max-w-2xl mx-auto mt-8 mb-8">
                    <div className="bg-gradient-to-r from-theme-blue via-blue-600 to-theme-yellow rounded-2xl shadow-2xl overflow-hidden">
                        <div className="bg-white/95 backdrop-blur-sm p-6 md:p-8">
                            <div className="text-center">
                                <h1 className="text-3xl md:text-4xl font-black text-theme-blue mb-2">Editar mi perfil</h1>
                                <p className="text-gray-600 text-base">Actualiza tu información personal y mejora tu perfil</p>
                            </div>
                        </div>
                    </div>
                </div>

                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-10 space-y-8 mb-8"
                >
                    {/* Sección de foto */}
                    <div className="flex flex-col items-center space-y-6 pb-8 border-b-2 border-gray-100">
                        <div className="relative w-40 h-40 group">
                            <div className="absolute inset-0 bg-gradient-to-br from-theme-blue to-theme-yellow rounded-full p-1">
                                <div className="w-full h-full bg-white rounded-full p-1">
                                    <img
                                        src={
                                            imagenPreview ||
                                            "https://cdn-icons-png.flaticon.com/512/847/847969.png"
                                        }
                                        alt="Foto de perfil"
                                        className="w-full h-full rounded-full object-cover"
                                    />
                                </div>
                            </div>
                            {imagenPreview && (
                                <button
                                    type="button"
                                    onClick={handleEliminarFoto}
                                    className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 rounded-full p-2 shadow-lg transition-all duration-300 hover:scale-110"
                                    title="Eliminar foto de perfil"
                                >
                                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            )}
                        </div>
                        <div className="text-center">
                            <h3 className="text-xl font-bold text-theme-blue mb-2">Foto de perfil</h3>
                            <p className="text-sm text-gray-600 mb-4">Sube una imagen para personalizar tu perfil</p>
                        </div>
                    </div>

                    <div>
                        <h2 className="text-2xl font-bold text-theme-blue mb-6 flex items-center gap-3">
                            <span className="bg-gradient-to-r from-theme-blue to-theme-yellow w-1 h-8 rounded-full"></span>
                            Datos personales
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="group">
                                <label className="block text-theme-blue font-semibold mb-2 flex items-center gap-2">
                                    <span className="text-xl">{getFieldIcon("correo")}</span>
                                    Correo electrónico
                                </label>
                                <input
                                    type="email"
                                    {...register("correo")}
                                    className="w-full border-2 border-gray-200 px-4 py-3 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-theme-blue transition-all duration-300 hover:border-theme-blue/50"
                                />
                            </div>

                            <div className="group">
                                <label className="block text-theme-blue font-semibold mb-2 flex items-center gap-2">
                                    <span className="text-xl">{getFieldIcon("celular")}</span>
                                    Teléfono
                                </label>
                                <input
                                    type="text"
                                    {...register("celular")}
                                    className="w-full border-2 border-gray-200 px-4 py-3 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-theme-blue transition-all duration-300 hover:border-theme-blue/50"
                                />
                            </div>

                            <div className="group">
                                <label className="block text-theme-blue font-semibold mb-2 flex items-center gap-2">
                                    <span className="text-xl">{getFieldIcon("fechaNacimiento")}</span>
                                    Fecha de nacimiento
                                </label>
                                <input
                                    type="date"
                                    {...register("fechaNacimiento")}
                                    className="w-full border-2 border-gray-200 px-4 py-3 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-theme-blue transition-all duration-300 hover:border-theme-blue/50"
                                />
                            </div>

                            <div className="md:col-span-2 group">
                                <label className="block text-theme-blue font-semibold mb-2 flex items-center gap-2">
                                    <span className="text-xl">{getFieldIcon("imagen")}</span>
                                    Cambiar foto de perfil
                                </label>
                                <div className="relative">
                                    <input
                                        type="file"
                                        {...register("imagen")}
                                        accept="image/*"
                                        className="w-full file:mr-4 file:py-3 file:px-6 file:rounded-xl file:border-0 file:text-sm file:font-semibold file:bg-gradient-to-r file:from-theme-blue file:to-blue-600 file:text-white hover:file:from-blue-700 hover:file:to-blue-800 file:cursor-pointer file:transition-all file:duration-300 border-2 border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-theme-blue transition-all duration-300 hover:border-theme-blue/50"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                const validExtensions = ["image/jpeg", "image/png", "image/jpg"];
                                                const maxSize = 5 * 1024 * 1024;

                                                if (!validExtensions.includes(file.type)) {
                                                    showErrorAlert({
                                                        title: "Formato inválido",
                                                        text: "Solo se permiten imágenes JPG, JPEG o PNG.",
                                                    });
                                                    return;
                                                }

                                                if (file.size > maxSize) {
                                                    showErrorAlert({
                                                        title: "Tamaño excedido",
                                                        text: "La imagen no debe superar los 5MB.",
                                                    });
                                                    return;
                                                }

                                                const reader = new FileReader();
                                                reader.onload = (ev) => setImagenPreview(ev.target?.result);
                                                reader.readAsDataURL(file);
                                            }
                                        }}
                                    />
                                    <p className="text-xs text-gray-500 mt-2">Formato: JPG, PNG. Tamaño máximo: 5MB</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Sección de ubicación */}
                    <div className="pt-8 border-t-2 border-gray-100">
                        <h2 className="text-2xl font-bold text-theme-blue mb-6 flex items-center gap-3">
                            <span className="bg-gradient-to-r from-theme-blue to-theme-yellow w-1 h-8 rounded-full"></span>
                            Ubicación
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="md:col-span-2 group">
                                <label className="block text-theme-blue font-semibold mb-2 flex items-center gap-2">
                                    <span className="text-xl">{getFieldIcon("pais")}</span>
                                    País
                                </label>
                                <select
                                    value={paisSeleccionado || ""}
                                    onChange={handlePaisChange}
                                    className="w-full border-2 border-gray-200 px-4 py-3 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-theme-blue transition-all duration-300 hover:border-theme-blue/50 bg-white"
                                >
                                    <option value="">Selecciona un país</option>
                                    {paises.map((p) => (
                                        <option key={p.idPais} value={p.idPais}>{p.nombre}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="group">
                                <label className="block text-theme-blue font-semibold mb-2 flex items-center gap-2">
                                    <span className="text-xl">{getFieldIcon("departamento")}</span>
                                    Departamento
                                </label>
                                <select
                                    value={departamentoSeleccionado || ""}
                                    onChange={handleDepartamentoChange}
                                    className="w-full border-2 border-gray-200 px-4 py-3 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-theme-blue transition-all duration-300 hover:border-theme-blue/50 bg-white"
                                >
                                    <option value="">Selecciona un departamento</option>
                                    {departamentos.map((d) => (
                                        <option key={d.idDepartamento} value={d.idDepartamento}>{d.nombre}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="group">
                                <label className="block text-theme-blue font-semibold mb-2 flex items-center gap-2">
                                    <span className="text-xl">{getFieldIcon("provincia")}</span>
                                    Provincia
                                </label>
                                <select
                                    value={provinciaSeleccionada || ""}
                                    onChange={handleProvinciaChange}
                                    className="w-full border-2 border-gray-200 px-4 py-3 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-theme-blue transition-all duration-300 hover:border-theme-blue/50 bg-white"
                                >
                                    <option value="">Selecciona una provincia</option>
                                    {provincias.map((pr) => (
                                        <option key={pr.idProvincia} value={pr.idProvincia}>{pr.nombre}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row justify-between gap-4 pt-6 border-t-2 border-gray-100">
                        <button
                            type="button"
                            onClick={() => navigate("/perfilAdm")}
                            className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-8 py-3 rounded-xl font-semibold transition-all duration-300 hover:shadow-lg flex items-center justify-center gap-2"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            Cancelar
                        </button>

                        <button
                            type="submit"
                            className="bg-gradient-to-r from-theme-blue to-blue-600 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 hover:shadow-xl hover:scale-105 flex items-center justify-center gap-2"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            Guardar cambios
                        </button>
                    </div>
                </form>
            </ContenedorPageTemplate>
        </div>
    );
};